import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

const Edit = ({ show, onClose, scheduleId, onUpdated }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [name, setName] = useState('');
    const [serviceSttm, setServiceSttm] = useState(null);
    const [serviceEdtm, setServiceEdtm] = useState(null);
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');

    useEffect(() => {
        if (show && scheduleId) {
            axios.get(`${baseURL}/item-schedule/${scheduleId}`)
                .then(response => {
                    const {
                        itemschedule_name,
                        description,
                        production_start_time,
                        production_end_time,
                    } = response.data.data;

                    setName(itemschedule_name || '');
                    setDescription(description || '');

                    if (production_start_time) {
                        const [startHour, startMinute, startSecond] = production_start_time.split(":");
                        setServiceSttm(new DateObject().set({ hour: +startHour, minute: +startMinute, second: +startSecond }));
                    }

                    if (production_end_time) {
                        const [endHour, endMinute, endSecond] = production_end_time.split(":");
                        setServiceEdtm(new DateObject().set({ hour: +endHour, minute: +endMinute, second: +endSecond }));
                    }
                })
                .catch(error => {
                    console.error("Error fetching item schedule:", error);
                });
        }
    }, [show, scheduleId]);

    const handleNameChange = (e) => {
        let value = e.target.value || '';
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setName(value);
        if (value.length <= 300) setNameLengthError('');
    };

    const handleDescriptionChange = (e) => {
        let value = e.target.value || '';
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setDescription(value);
        if (value.length <= 500) setDescLengthError('');
    };

    const handleSubmit = () => {
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');

        const safeName = name?.trim() || '';
        const safeDescription = description?.trim() || '';

        if (!safeName) {
            setErrors(prev => ({ ...prev, itemschedule_name: "This Field is Required" }));
            return;
        }

        if (safeName.length > 300) {
            setNameLengthError('Limit reached (max 300 characters)');
            return;
        }

        if (safeDescription.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
            return;
        }

        if (!serviceSttm || !serviceEdtm) {
            setErrors(prev => ({
                ...prev,
                production_start_time: !serviceSttm ? "Start time required" : undefined,
                production_end_time: !serviceEdtm ? "End time required" : undefined,
            }));
            return;
        }

        axios.put(`${baseURL}/item-schedule/${scheduleId}`, {
            itemschedule_name: safeName,
            production_start_time: serviceSttm.format("hh:mm A"),
            production_end_time: serviceEdtm.format("hh:mm A"),
            description: safeDescription,
        })
            .then(() => {
                onClose();
                if (onUpdated) onUpdated();
            })
            .catch(error => {
                if (error.response?.status === 400 && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    console.error("Update failed:", error);
                }
            });
    };

    return (
        <Modal show={show} onHide={onClose} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Item Schedule</h3>
                    <Button variant="" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Item Schedule <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.itemschedule_name ? 'is-invalid' : ''}`}
                                placeholder="Enter Item Category"
                                value={name}
                                onChange={handleNameChange}
                            />
                            {errors.itemschedule_name && (
                                <div className="invalid-feedback">{errors.itemschedule_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger">{nameLengthError}</span>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Production Start Time <span className="required">*</span>
                            </label>
                            <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className="fa-solid fa-clock fs-4"></i>
                                </div>
                                <DatePicker
                                    placeholder="Select Time"
                                    disableDayPicker
                                    value={serviceSttm}
                                    onChange={setServiceSttm}
                                //    format="hh : mm A"
                                   format="HH:mm" 
                                    plugins={[<TimePicker />]}
                                />
                            </div>
                            {errors.production_start_time && <div className="text-danger">{errors.production_start_time}</div>}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Production End Time <span className="required">*</span>
                            </label>
                            <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                <div className='input-group-text bg-transparent border-0 px-0'>
                                    <i className='fa-solid fa-clock fs-4'></i>
                                </div>
                                <DatePicker
                                    placeholder="Select Time"
                                    disableDayPicker
                                    value={serviceEdtm}
                                    onChange={setServiceEdtm}
                                    // format="hh : mm A"
                                       format="HH:mm" 
                                    plugins={[<TimePicker />]}
                                />
                            </div>
                            {errors.production_end_time && <div className="text-danger">{errors.production_end_time}</div>}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
                        <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
                        <Button variant="primary" size="sm" onClick={handleSubmit}>Update Item Schedule</Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Edit;
